export const itemsSearch = {
  criterions: {
    name: "Название",
    vendor_code: "Артикул",
    type: "Тип",
    barcode: "Штрихкод",
  },
  tabTitles: {
    isSuccessful: [
      "Все совпадения",
      "Ткани",
      "Фурнитура",
      "Продукты",
      "Крой",
      "Канцелярия",
      "Расходники",
      "Рекламная продукция",
      "Упаковка",
    ],
    isFailed: ["Пустой ответ"],
  },
  placeholders: {
    barcode: "Введите штрихкод",
    name: "Введите название",
    type: "Введите тип",
    vendor_code: "Введите артикул",
  },
  tables: {
    "Все совпадения": "all",
    Ткани: "cloths",
    Фурнитура: "sewing_accessories",
    Продукты: "products",
    Крой: "cut_of_clothes",
    Канцелярия: "stationery",
    Расходники: "expendable_materials",
    "Рекламная продукция": "promotional_products",
    Упаковка: "packages",
  },
  subtypes: {
    Ткани: "cloth",
    Расходники: "expendable_material",
    Фурнитура: "sewing_accessory",
    Продукты: "product",
    Крой: "cut_of_clothes",
    Канцелярия: "stationery",
    "Рекламная продукция": "promotional_product",
    Упаковка: "package",
  },
};



// WEBPACK FOOTER //
// ./src/stock/constants/itemsSearch.js